module.exports = __webpack_public_path__ + "img/pay-per-click.f3ed3e09.png";